import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EditCategory from "../../../components/SuperAdmin/Category/EditCategory";

export default withRouter(connect()(EditCategory));
